import type { AxiosResponse } from "axios";
import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "./commonLanguageHeader";
import { ServicesUrlEndpoints } from "./servicesEndpointConstant";

export interface TachographCompanySettings {
  enabled: boolean;
  customerId?: string | number | null;
  externalId?: string | null;
  vehicleSchedule?: number | null;
  driverSchedule?: number | null;
  [key: string]: unknown;
}

export interface TachographCompanySettingsPayload {
  customerId: number;
  enabled: boolean;
  vehicleSchedule: number | null;
  driverSchedule: number | null;
}

const getTachoCompanyByCustomerUrl = (customerId: string | number) =>
  ServicesUrlEndpoints.TACHO_COMPANY.GET_BY_CUSTOMER.replace(
    "{customerId}",
    String(customerId),
  );

export const getTachographCompanySettingsByCustomerId = (
  customerId: string | number,
  language?: string,
): Promise<AxiosResponse<{ response: TachographCompanySettings | null }>> =>
  ApiService.get(getTachoCompanyByCustomerUrl(customerId), {
    ...getLanguageHeaders(language),
  });

export const saveTachographCompanySettings = (
  payload: TachographCompanySettingsPayload,
  language?: string,
) =>
  ApiService.post(ServicesUrlEndpoints.TACHO_COMPANY.SAVE_OR_UPDATE, payload, {
    ...getLanguageHeaders(language),
  });

export interface TachographCompanyLookupItem {
  id: string | number;
  name: string;
}

export const getTachographCompanyLookup = (language?: string) =>
  ApiService.get<TachographCompanyLookupItem[] | { response?: TachographCompanyLookupItem[] }>(
    ServicesUrlEndpoints.TACHO_COMPANY.LOOKUP,
    getLanguageHeaders(language),
  );
